export default "__VITE_ASSET__DumFf0dm__"